import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import {jobBuilderStyles} from '../shared/styles-job-builder';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';

const ReportInput = ({item}) => {
    return (
        <span className="report" style={jobBuilderStyles.buttonLabel}>
            <span style={jobBuilderStyles.buttonName}>{item.title}</span>
            <span className="job-select-description">
                <ReactMarkdown>{item.description}</ReactMarkdown>
            </span>
        </span>
    )
}

class JobReportBuilderReportSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: props.expanded,
            selectedReport: {
                id: null,
                title: null
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            (nextProps.expanded && (!this.props.expanded || !this.state.expanded)) ||
            (!nextProps.expanded && (this.props.expanded || this.state.expanded))
        ) {
            this.setState({
                expanded: nextProps.expanded
            });
        }
        if (nextProps.selected.id !== this.props.selected.id) {
            this.setState({
                selectedReport: {
                    id: nextProps.selected.id,
                    title: nextProps.selected.title
                }
            });
        }
        if (JSON.stringify(nextProps.reportChoices) !== JSON.stringify(this.props.reportChoices)) {
            this.setState({
                reportChoices: nextProps.reportChoices
            });
        }
    }

    renderReportOptions = (list) => {
        if (!list || list.length === 0) {
            return (
                [0].map(() => (
                    <span key="job-report-0"></span>
                ))
            )
        }
        return list.map((item, idx) =>
            <RadioButton
                key={`job-report-${item.id}-${idx}`}
                value={item.id}
                label={<ReportInput item={item}/>}
                style={jobBuilderStyles.button}
                iconStyle={jobBuilderStyles.buttonIcon}
            />
        );
    };

    handleExpandChange = (expanded) => {
        this.setState({expanded: expanded});
    };

    handleReportSelect = (e) => {
        const value = (e && e.target && e.target.value) ? e.target.value : '';
        let selectedReport = {
            id: null,
            title: null
        };
        const choice = this.props.reportChoices.find(r => r.id === value);
        if (choice) {
            selectedReport.id = value;
            selectedReport.title = choice.title;
        }
        this.setState({
            selectedReport: selectedReport
        }, () => {
            if (typeof this.props.onSelectReport === 'function') {
                this.props.onSelectReport(value);
            }
        });
    };

    render() {
        const {
            reportChoices,
            selected
        } = this.props;

        const {
            expanded,
            selectedReport
        } = this.state;

        const title = (selectedReport.id) ? 'Report - ' + selectedReport.title : 'Choose a Report to Configure';

        if (reportChoices.length === 0) {
            return (
                <Card containerStyle={jobBuilderStyles.cardContainer} style={jobBuilderStyles.card}>
                    <CardHeader
                        title="No Reports Available"
                        actAsExpander={false}
                        showExpandableButton={false}
                        style={jobBuilderStyles.cardHeader}
                        textStyle={jobBuilderStyles.cardHeaderText}
                    />
                </Card>
            )
        }

        return (
            <Card
                expanded={expanded}
                onExpandChange={this.handleExpandChange}
                containerStyle={jobBuilderStyles.cardContainer}
                style={jobBuilderStyles.card}
            >
                <CardHeader
                    title={title}
                    actAsExpander={true}
                    showExpandableButton={true}
                    style={jobBuilderStyles.cardHeader}
                    textStyle={jobBuilderStyles.cardHeaderText}
                />
                <CardText expandable={true} style={jobBuilderStyles.cardText}>
                    <RadioButtonGroup
                        name="category"
                        onChange={(e) => this.handleReportSelect(e)}
                        valueSelected={selected}
                        style={jobBuilderStyles.group}
                    >
                        {[...this.renderReportOptions(reportChoices)]}
                    </RadioButtonGroup>
                </CardText>
            </Card>
        )
    }
}

JobReportBuilderReportSelect.propTypes = {
    configData: PropTypes.object,
    expanded: PropTypes.bool,
    onSelectReport: PropTypes.func,
    reportChoices: PropTypes.array,
    selected: PropTypes.string
};

JobReportBuilderReportSelect.defaultProps = {
    configData: null,
    expanded: true,
    reportChoices: []
};

export default JobReportBuilderReportSelect;



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobBuilderReportSelect.js